import * as React from 'react';

const TypedSelect = <T extends string>(
	props: React.HTMLAttributes<HTMLSelectElement> & {
		options: { disabled?: boolean; key?: string; value: T | null; title: string | null | undefined }[];
		value: T;
		onTypedValueChange: (value: T) => void;
	}
) => {
	const { options, value, onTypedValueChange, ...selectProps } = props;

	return (
		<select
			{...selectProps}
			value={value || ''}
			onChange={(event) => {
				const nextValue = event.target.value as T;
				onTypedValueChange(nextValue);
			}}
		>
			{options.map(({ disabled, key, value, title }) => (
				<option disabled={disabled} key={key || value} value={value || ''}>
					{title}
				</option>
			))}
		</select>
	);
};

export default React.memo(TypedSelect) as typeof TypedSelect;
